<template>
  <div class="input">
    <el-form-item :label="label" :prop="name" >
      <el-radio-group v-model="value" @input="onInput(name, $event)">
        <el-radio-button v-for="radio in radios" :key="radio.id" :label="radio.name">
          {{radio.name}}
        </el-radio-button>
      </el-radio-group>
    </el-form-item>

  </div>
</template>
<script>
  export default {
    props: {
      label: String,
      name:String,
      radios: Array,
      activeIndex: String
    },
    data: function () {
        return {
            value:null,
        }
    },
    watch: {
      activeIndex: function () {
        this.value = null
      }
    },
    mounted: function () {
      this.init();
    },
    methods: {
      init: function () {

        },
      onInput: function (name,val) {
          this.$emit('input', {[name]:val})
      },
     }
  }
</script>
